import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "p-jobsearch-search_card" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "p-jobsearch-search_card_header __sub" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "p-jobsearch-search_card_header_hl" }, "職種を選択"),
  /*#__PURE__*/_createElementVNode("button", {
    class: "p-jobsearch-search_card_header_back js-modal-close-trigger",
    type: "button"
  }, [
    /*#__PURE__*/_createElementVNode("span", null, "戻る")
  ])
], -1)
const _hoisted_3 = { class: "p-jobsearch-search_card_body __sub js-tab-container" }
const _hoisted_4 = { class: "p-jobsearch-search_card_sub __no-sp" }
const _hoisted_5 = { class: "p-jobsearch-search_tab" }
const _hoisted_6 = ["data-tab"]
const _hoisted_7 = { class: "p-jobsearch-search_card_main __no-tab" }
const _hoisted_8 = {
  class: "p-jobsearch-search_content __sub",
  id: "jobsearch-occup-dialog-body"
}
const _hoisted_9 = ["id"]
const _hoisted_10 = { class: "p-jobsearch-search_accordion __first" }
const _hoisted_11 = { class: "p-jobsearch-search_accordion_wp js-check-parent_wp" }
const _hoisted_12 = { class: "p-jobsearch-search_check" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", { class: "p-jobsearch-search_check_icon" }, null, -1)
const _hoisted_14 = ["checked", "onChange"]
const _hoisted_15 = ["onClick"]
const _hoisted_16 = { class: "p-jobsearch-search_accordion_wp js-check-parent_wp" }
const _hoisted_17 = { class: "p-jobsearch-search_check" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", { class: "p-jobsearch-search_check_icon" }, null, -1)
const _hoisted_19 = ["checked", "onChange"]
const _hoisted_20 = ["onClick"]
const _hoisted_21 = { class: "p-jobsearch-search_accordions" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("span", { class: "p-jobsearch-search_check_icon" }, null, -1)
const _hoisted_23 = ["checked", "onChange"]
const _hoisted_24 = /*#__PURE__*/_createElementVNode("div", { class: "p-jobsearch-search_bg js-modal-close-trigger" }, null, -1)

import { JobSearchSelectedCheckboxListItem } from '@/types';
import { DialogOccupData, MstOccupClass1, MstOccupClass2, MstOccupClass3 } from '@/types/mstMyPage';
import { domHelperUtils } from '@/utils/domHelper';
import { computed, onMounted, ref, watch } from 'vue';
import { useStore } from 'vuex';
import { MYPAGE_CONSTANTS } from '@/constants/mypage';

export default /*#__PURE__*/_defineComponent({
  __name: 'Occupation',
  props: {
    selectedOccupations: null,
    refreshKey: null
  },
  emits: ["update:selectedOccupations"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'update:selectedOccupations', value: {
    jobsearchOcupctg1id: string[],
    jobsearchOcupctg2id: string[],
    jobsearchOcupctg3id: string[],
    displayOccupList: JobSearchSelectedCheckboxListItem[],
  }): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  selectedOccupations?: {
    jobsearchOcupctg1id: string[],
    jobsearchOcupctg2id: string[],
    jobsearchOcupctg3id: string[],
    displayOccupList: JobSearchSelectedCheckboxListItem[],
  },
  refreshKey: number,
}

const storeBase = MYPAGE_CONSTANTS.STORE_MST;

const dialogData = ref<DialogOccupData>();





watch(() => props.selectedOccupations, (newValue) => {
  if (newValue && dialogData.value) {
    updateCheckboxesFromIds(newValue);
  }
}, { deep: true });

watch(() => props.refreshKey, () =>{
  setTimeout(()=>{
    emit('update:selectedOccupations', selectedOccupations.value);
  });
});

const selectedOccupations = computed(() => {
  if (!dialogData.value) return {
    jobsearchOcupctg1id: [],
    jobsearchOcupctg2id: [],
    jobsearchOcupctg3id: [],
    displayOccupList: [],
  };

  const result = {
    jobsearchOcupctg1id: [] as string[],
    jobsearchOcupctg2id: [] as string[],
    jobsearchOcupctg3id: [] as string[],
    displayOccupList: [] as JobSearchSelectedCheckboxListItem[],
  };

  dialogData.value.selectbox1.forEach(box1 => {
    // selectbox1がチェックされている場合、そのIDをjobsearchOcupctg1idに追加
    if (box1.isChecked) {
      result.jobsearchOcupctg1id.push(box1.value);
      result.displayOccupList.push({
        id: box1.value,
        // eslint-disable-next-line no-irregular-whitespace
        text: `${box1.text}　すべて`,
        isChecked: true,
        level: 1,
      });
    } else {
      // selectbox1がチェックされていない場合、チェックされているselectbox2を処理
      box1.selectbox2.forEach(box2 => {
        if (box2.isChecked) {
          // selectbox2がチェックされている場合、そのIDをjobsearchOcupctg2idに追加
          result.jobsearchOcupctg2id.push(box2.id.toString());
          result.displayOccupList.push({
            id: box2.id.toString(),
            text: `${box1.text} ${box2.text}`,
            isChecked: true,
            level: 2,
          });
        } else {
          // selectbox2もチェックされていない場合、チェックされているselectbox3を処理
          box2.selectbox3.forEach(box3 => {
            if (box3.isChecked) {
              // selectbox3がチェックされている場合、そのIDをjobsearchOcupctg3idに追加
              result.jobsearchOcupctg3id.push(box3.value);
              result.displayOccupList.push({
                id: box3.value,
                text: `${box1.text} ${box2.text} - ${box3.text}`,
                isChecked: true,
                level: 3,
              });
            }
          });
        }
      });
    }
  });
  
  return result;
});

// 条件をクリア
function clearAllSelections() {
  if (!dialogData.value) return;
  
  // すべてのチェックボックスの選択を解除
  dialogData.value.selectbox1.forEach(box1 => {
    // 第1階層のチェックボックスをクリア
    box1.isChecked = false;
    
    box1.selectbox2.forEach(box2 => {
      // 第2階層のチェックボックスをクリア
      box2.isChecked = false;
      
      box2.selectbox3.forEach(box3 => {
        // 第3階層のチェックボックスをクリア
        box3.isChecked = false;
      });
    });
  });
  
  // 親コンポーネントに空のオブジェクトを送信
  emit('update:selectedOccupations', {
    jobsearchOcupctg1id: [],
    jobsearchOcupctg2id: [],
    jobsearchOcupctg3id: [],
    displayOccupList: [],
  });
}

// 指定する
function submitSelection() {
  emit('update:selectedOccupations', selectedOccupations.value);
  
  // remove opened items style
  const openedItems = document.querySelectorAll('#jobsearch-occup-dialog-body .-is-opened');
  setTimeout(() => {
    openedItems.forEach(item => {
      (item as HTMLElement).style = '';
    });
  });
}

function updateCheckboxesFromIds(selectedData: {
  jobsearchOcupctg1id: string[],
  jobsearchOcupctg2id: string[],
  jobsearchOcupctg3id: string[],
  displayOccupList: JobSearchSelectedCheckboxListItem[],
}) {
  if (!dialogData.value) return;

  // まずすべてのチェックボックスをクリア
  dialogData.value.selectbox1.forEach(box1 => {
    box1.isChecked = false;
    box1.isOpened = false;
    box1.selectbox2.forEach(box2 => {
      box2.isChecked = false;
      box2.isOpened = false;
      box2.selectbox3.forEach(box3 => {
        box3.isChecked = false;
      });
    });
  });

  // selectbox1（第1階層）のチェックを設定
  dialogData.value.selectbox1.forEach(box1 => {
    if (selectedData.jobsearchOcupctg1id.includes(box1.value)) {
      box1.isChecked = true;
      box1.isOpened = false;
      // 第1階層がチェックされている場合、すべての子要素もチェック
      box1.selectbox2.forEach(box2 => {
        box2.isChecked = true;
        box2.selectbox3.forEach(box3 => {
          box3.isChecked = true;
        });
      });
    }
  });

  // selectbox2（第2階層）のチェックを設定（selectbox1がチェックされていない場合のみ）
  dialogData.value.selectbox1.forEach(box1 => {
    if (!box1.isChecked) {
      box1.selectbox2.forEach(box2 => {
        if (selectedData.jobsearchOcupctg2id.includes(box2.id.toString())) {
          box2.isChecked = true;
          box2.isOpened = false;
          box1.isOpened = true;
          // 第2階層がチェックされている場合、すべての子要素もチェック
          box2.selectbox3.forEach(box3 => {
            box3.isChecked = true;
          });
        }
      });
    }
  });

  // selectbox3（第3階層）のチェックを設定（selectbox1とselectbox2がチェックされていない場合のみ）
  dialogData.value.selectbox1.forEach(box1 => {
    if (!box1.isChecked) {
      let isBox1Open = false;
      box1.selectbox2.forEach(box2 => {
        let isBox2Open = false;
        if (!box2.isChecked) {
          box2.selectbox3.forEach(box3 => {
            if (selectedData.jobsearchOcupctg3id.includes(box3.value)) {
              box3.isChecked = true;
              isBox1Open = true;
              isBox2Open = true;
            }
          });

          // box2の状態を更新（すべての子要素がチェックされていれば親もチェック）
          const allBox3Checked = box2.selectbox3.every(box3 => box3.isChecked);
          box2.isChecked = allBox3Checked;
          box2.isOpened = !allBox3Checked && isBox2Open;
        }
      });

      // box1の状態を更新（すべての子要素がチェックされていれば親もチェック）
      const allBox2Checked = box1.selectbox2.every(box2 => box2.isChecked);
      box1.isChecked = allBox2Checked;
      if (!box1.isOpened) {
        box1.isOpened = !allBox2Checked && isBox1Open;
      }
    }
  });

  // re-open checked sections
  const openedItems = document.querySelectorAll('#jobsearch-occup-dialog-body .-is-opened');
  setTimeout(() => {
    openedItems.forEach(item => {
      if ((item as HTMLElement).style.display == 'none') {
        (item as HTMLElement).style.display = '';
      }
    });
  });
}

const store = useStore();
onMounted(async () => {
  dialogData.value = await store.dispatch(storeBase.DIALOG_OCCUPATION);

  // 初期選択値があれば設定
  if (props.selectedOccupations && 
      (props.selectedOccupations.jobsearchOcupctg1id.length > 0 || 
       props.selectedOccupations.jobsearchOcupctg2id.length > 0 ||
       props.selectedOccupations.jobsearchOcupctg3id.length > 0)) {
    updateCheckboxesFromIds(props.selectedOccupations);
  }
});

function handleCheckbox1(checkbox: MstOccupClass1, isChecked: boolean) {
  // チェックボックス第1階層の状態を更新
  checkbox.isChecked = isChecked;
  
  // すべての第2階層チェックボックスを更新
  checkbox.selectbox2.forEach(box2 => {
    // チェックボックス第2階層の状態を更新
    box2.isChecked = isChecked;
    
    // すべての第3階層チェックボックスを更新
    box2.selectbox3.forEach(box3 => {
      box3.isChecked = isChecked;
    });
  });
}

function handleCheckbox2(checkbox: MstOccupClass2, isChecked: boolean) {
  // チェックボックス第2階層の状態を更新
  checkbox.isChecked = isChecked;

  // すべての第3階層チェックボックスを更新
  checkbox.selectbox3.forEach(box3 => {
    box3.isChecked = isChecked;
  });
  
  // 親box1のIDを取得（box2.idの最初の1文字）
  const parentBox1Id = checkbox.id.toString().substring(0, 1);
  
  // 親box1を検索
  const box1Index = dialogData.value!.selectbox1.findIndex(box1 => box1.id === parentBox1Id);
  if (box1Index < 0) return;
  
  const box1 = dialogData.value!.selectbox1[box1Index];
  
  // 親box1の状態を更新
  // すべてのbox2がチェックされている場合 -> box1をチェック
  // 少なくとも1つのbox2がチェックされていない場合 -> box1のチェックを外す
  const allBox2Checked = box1.selectbox2.every(box2 => box2.isChecked);
  box1.isChecked = allBox2Checked;
}

function handleCheckbox3(checkbox: MstOccupClass3, isChecked: boolean) {
  // チェックボックス第3階層の状態を更新
  checkbox.isChecked = isChecked;
  
  // 親box2のIDを取得（box3.idの最初の3文字）
  const parentBox2Id = checkbox.id.toString().substring(0, 3);
  // 親box1のIDを取得（box3.idの最初の1文字）
  const parentBox1Id = checkbox.id.toString().substring(0, 1);
  
  // 親box1を検索
  const box1Index = dialogData.value!.selectbox1.findIndex(box1 => box1.id === parentBox1Id);
  if (box1Index < 0) return;
  
  // 親box2を検索
  const box2Index = dialogData.value!.selectbox1[box1Index].selectbox2.findIndex(box2 => box2.id === parentBox2Id);
  if (box2Index < 0) return;
  
  const box2 = dialogData.value!.selectbox1[box1Index].selectbox2[box2Index];
  
  // 親box2の状態を更新
  // すべてのbox3がチェックされている場合 -> box2をチェック
  // 少なくとも1つのbox3がチェックされていない場合 -> box2のチェックを外す
  const allBox3Checked = box2.selectbox3.every(box3 => box3.isChecked);
  box2.isChecked = allBox3Checked;
  
  // 親box1の状態を更新
  // すべてのbox2がチェックされている場合 -> box1をチェック
  // 少なくとも1つのbox2がチェックされていない場合 -> box1のチェックを外す
  const box1 = dialogData.value!.selectbox1[box1Index];
  const allBox2Checked = box1.selectbox2.every(box2 => box2.isChecked);
  box1.isChecked = allBox2Checked;
}

function toggleBox1(target: HTMLElement, box1: MstOccupClass1) {
  const checkboxContainer = target.parentElement?.nextElementSibling as HTMLElement;
  if (checkboxContainer) {
    if (box1.isOpened) {
      domHelperUtils.toggle.initOpen(checkboxContainer);
      domHelperUtils.toggle.closeAccordion(checkboxContainer);
    } else {
      domHelperUtils.toggle.openAccordion(checkboxContainer);
    }
  }
  box1.isOpened = !box1.isOpened;
}
function toggleBox2(target: HTMLElement, box2: MstOccupClass2) {
  const checkboxContainer = target.parentElement?.nextElementSibling as HTMLElement;
  if (checkboxContainer) {
    if (box2.isOpened) {
      domHelperUtils.toggle.initOpen(checkboxContainer);
      domHelperUtils.toggle.closeAccordion(checkboxContainer);
    } else {
      domHelperUtils.toggle.openAccordion(checkboxContainer);
    }
  }
  box2.isOpened = !box2.isOpened;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dialogData.value?.selectbox1, (item, i) => {
              return (_openBlock(), _createElementBlock("div", {
                key: item.id,
                class: _normalizeClass(["p-jobsearch-search_tab_item js-tab-btn", { __current: !i}]),
                "data-tab": `job-tab${i + 1}`
              }, _toDisplayString(item.text), 11, _hoisted_6))
            }), 128))
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dialogData.value?.selectbox1, (box1, i) => {
              return (_openBlock(), _createElementBlock("div", {
                key: box1.id,
                class: _normalizeClass(["p-jobsearch-search_tab-content js-tab-target", { __current: !i}]),
                id: `job-tab${i + 1}`
              }, [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("label", _hoisted_12, [
                      _hoisted_13,
                      _createElementVNode("input", {
                        checked: box1.isChecked,
                        type: "checkbox",
                        onChange: ($event: any) => (handleCheckbox1(box1, ($event.target as HTMLInputElement).checked))
                      }, null, 40, _hoisted_14),
                      _createElementVNode("span", null, _toDisplayString(box1.text), 1)
                    ]),
                    _createElementVNode("span", {
                      class: _normalizeClass(["p-jobsearch-search_accordion_btn js-jobsearch-acc-toggle", { '-is-opened': box1.isOpened }]),
                      onClick: ($event: any) => (toggleBox1($event.target as HTMLElement, box1))
                    }, "開閉ボタン", 10, _hoisted_15)
                  ]),
                  _createElementVNode("div", {
                    class: _normalizeClass(["p-jobsearch-search_accordion_content __second js-jobsearch-acc-target", { '-is-opened': box1.isOpened }])
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(box1.selectbox2, (box2) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "p-jobsearch-search_accordion __second",
                        key: box2.id
                      }, [
                        _createElementVNode("div", _hoisted_16, [
                          _createElementVNode("label", _hoisted_17, [
                            _hoisted_18,
                            _createElementVNode("input", {
                              class: "js-check-parent",
                              checked: box2.isChecked,
                              type: "checkbox",
                              onChange: ($event: any) => (handleCheckbox2(box2, ($event.target as HTMLInputElement).checked))
                            }, null, 40, _hoisted_19),
                            _createElementVNode("span", null, _toDisplayString(box2.text), 1)
                          ]),
                          _createElementVNode("span", {
                            class: _normalizeClass(["p-jobsearch-search_accordion_btn js-jobsearch-acc-toggle", { '-is-opened': box2.isOpened }]),
                            onClick: ($event: any) => (toggleBox2($event.target as HTMLElement, box2))
                          }, "開閉ボタン", 10, _hoisted_20)
                        ]),
                        _createElementVNode("div", {
                          class: _normalizeClass(["p-jobsearch-search_accordion_content __third js-jobsearch-acc-target", { '-is-opened': box2.isOpened }])
                        }, [
                          _createElementVNode("div", _hoisted_21, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(box2.selectbox3, (box3) => {
                              return (_openBlock(), _createElementBlock("label", {
                                key: box3.id,
                                class: "p-jobsearch-search_check"
                              }, [
                                _hoisted_22,
                                _createElementVNode("input", {
                                  type: "checkbox",
                                  checked: box3.isChecked,
                                  onChange: ($event: any) => (handleCheckbox3(box3, ($event.target as HTMLInputElement).checked))
                                }, null, 40, _hoisted_23),
                                _createElementVNode("span", null, _toDisplayString(box3.text), 1)
                              ]))
                            }), 128))
                          ])
                        ], 2)
                      ]))
                    }), 128))
                  ], 2)
                ])
              ], 10, _hoisted_9))
            }), 128))
          ])
        ])
      ]),
      _createElementVNode("div", { class: "p-jobsearch-search_card_footer" }, [
        _createElementVNode("button", {
          class: "p-jobsearch-search_clear",
          id: "clearModalSearch3",
          type: "button",
          onClick: clearAllSelections
        }, "条件をクリア"),
        _createElementVNode("button", {
          class: "p-jobsearch-search_set js-modal-close-trigger",
          type: "button",
          onClick: submitSelection
        }, "指定する")
      ])
    ]),
    _hoisted_24
  ], 64))
}
}

})